import * as React from "react";
import { SVGProps, memo } from "react";
const SvgPublishedConnectionLive14Px = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={14}
    height={14}
    fill="none"
    role="img"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 1a1 1 0 0 1 1 1v1.5a.995.995 0 0 1-.134.501A.982.982 0 0 1 13 4.5V6a.995.995 0 0 1-.134.501A.982.982 0 0 1 13 7v1.5a1 1 0 0 1-1 1H7.424v.586c.436.154.778.502.924.941L8.338 11 13 11v1H8.338l.008-.022a1.5 1.5 0 0 1-2.796.124l-.04-.101L1 12v-1l4.51-.001-.01.028c.146-.439.489-.788.924-.942V9.5H2a1 1 0 0 1-1-1V7c0-.182.049-.353.134-.5A.993.993 0 0 1 1 6V4.5c0-.182.049-.353.134-.5A.993.993 0 0 1 1 3.5V2a1 1 0 0 1 1-1h10ZM6.924 11a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1ZM10 7H2v1.5h10V7h-1v1h-1V7Zm0-2.5H2V6h10V4.5h-1v1h-1v-1ZM10 2H2v1.5h10V2h-1v1h-1V2Z"
      fill="#666"
    />
  </svg>
);
const Memo = memo(SvgPublishedConnectionLive14Px);
export default Memo;
